"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveCacheFile = exports.readCacheFile = exports.setUrlInCache = exports.getResultFromCache = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _fs = _interopRequireDefault(require("fs"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var makeFolder = function makeFolder(categoryName) {
  var _categoryName$match, _categoryName$match$s;
  var foundFolderMoreTheOne = categoryName === null || categoryName === void 0 ? void 0 : (_categoryName$match = categoryName.match(/[^\s\/]*\//g)) === null || _categoryName$match === void 0 ? void 0 : (_categoryName$match$s = _categoryName$match.splice(0, 3)) === null || _categoryName$match$s === void 0 ? void 0 : _categoryName$match$s.join("");
  return foundFolderMoreTheOne ? foundFolderMoreTheOne : "".concat(categoryName, "/");
};
var hasSpecialCharactersInUrl = function hasSpecialCharactersInUrl(url) {
  return /[?;=&%]/.test(url);
};
var fileExist = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var fullCacheFilePath, fileHandle;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fullCacheFilePath = _ref.fullCacheFilePath;
            _context.prev = 1;
            _context.next = 4;
            return _fs["default"].promises.open(fullCacheFilePath);
          case 4:
            fileHandle = _context.sent;
            return _context.abrupt("return", {
              fileHandle: fileHandle
            });
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", {
              fileHandle: false
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));
  return function fileExist(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var fileStats = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3) {
    var fullCacheFilePath, stats;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fullCacheFilePath = _ref3.fullCacheFilePath;
            _context2.prev = 1;
            _context2.next = 4;
            return _fs["default"].promises.stat(fullCacheFilePath);
          case 4:
            stats = _context2.sent;
            return _context2.abrupt("return", {
              stats: stats
            });
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            throw Error("Stats file ".concat(fullCacheFilePath, " error ").concat(_context2.t0, " "));
          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));
  return function fileStats(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var writeFile = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref5) {
    var fileName, result, jsonData;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            fileName = _ref5.fileName, result = _ref5.result;
            _context3.prev = 1;
            jsonData = JSON.stringify(Array.isArray(result) ? (0, _toConsumableArray2["default"])(result) : _objectSpread({}, result));
            _context3.next = 5;
            return _fs["default"].promises.writeFile(fileName, jsonData);
          case 5:
            return _context3.abrupt("return");
          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            console.log("Error on write file", fileName, _context3.t0);
          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 8]]);
  }));
  return function writeFile(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var mkdir = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref7) {
    var folders;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            folders = _ref7.folders;
            _context4.prev = 1;
            _context4.next = 4;
            return _fs["default"].promises.mkdir(folders, {
              recursive: true
            });
          case 4:
            return _context4.abrupt("return", {
              folderCreated: true
            });
          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", {
              folderCreated: false
            });
          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 7]]);
  }));
  return function mkdir(_x4) {
    return _ref8.apply(this, arguments);
  };
}();
var access = /*#__PURE__*/function () {
  var _ref10 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(_ref9) {
    var fileOrFolder;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            fileOrFolder = _ref9.fileOrFolder;
            _context5.prev = 1;
            _context5.next = 4;
            return _fs["default"].promises.access(fileOrFolder);
          case 4:
            return _context5.abrupt("return", {
              isExist: true
            });
          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", {
              isExist: false
            });
          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 7]]);
  }));
  return function access(_x5) {
    return _ref10.apply(this, arguments);
  };
}();
var isCharsInLimit = function isCharsInLimit(fileName) {
  return !fileName || fileName.length < 255;
};
var readCacheFile = /*#__PURE__*/function () {
  var _ref12 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(_ref11) {
    var cacheFilePath, contextRequest, requestPath, _ref11$constantFileNa, constantFileName, _ref11$separateFolder, separateFolder, _ref11$forPrismic, forPrismic, _requestPath$replace, _requestPath$replace$, _filenameCategoryCach, initialCacheFilePath, filenameCategoryCache, fullCacheFilePath, hasFolder, _yield$fileExist, fileHandle, _yield$fileStats, stats, diffTime, result;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            cacheFilePath = _ref11.cacheFilePath, contextRequest = _ref11.contextRequest, requestPath = _ref11.requestPath, _ref11$constantFileNa = _ref11.constantFileName, constantFileName = _ref11$constantFileNa === void 0 ? false : _ref11$constantFileNa, _ref11$separateFolder = _ref11.separateFolder, separateFolder = _ref11$separateFolder === void 0 ? false : _ref11$separateFolder, _ref11$forPrismic = _ref11.forPrismic, forPrismic = _ref11$forPrismic === void 0 ? false : _ref11$forPrismic;
            if (!(global.__appConfig__.cacheSystemEnabled && contextRequest && !process.browser && !hasSpecialCharactersInUrl(requestPath) && isCharsInLimit(requestPath))) {
              _context6.next = 40;
              break;
            }
            initialCacheFilePath = "".concat(global.__appConfig__.cachePath).concat(cacheFilePath);
            filenameCategoryCache = !separateFolder ? requestPath === null || requestPath === void 0 ? void 0 : (_requestPath$replace = requestPath.replace(/\//gi, "---")) === null || _requestPath$replace === void 0 ? void 0 : (_requestPath$replace$ = _requestPath$replace.replace(/\?/gi, "--")) === null || _requestPath$replace$ === void 0 ? void 0 : _requestPath$replace$.replace(/&/gi, "--") : requestPath;
            filenameCategoryCache = "".concat(constantFileName ? constantFileName : filenameCategoryCache, ".json");
            fullCacheFilePath = "".concat(initialCacheFilePath);
            hasFolder = separateFolder && ((_filenameCategoryCach = filenameCategoryCache.match(/[a-z-]*\//gm)) === null || _filenameCategoryCach === void 0 ? void 0 : _filenameCategoryCach.join(""));
            if (separateFolder && !hasFolder) {
              hasFolder = makeFolder(filenameCategoryCache.replace(".json", "").replace(/-\d+(?!\d+)$/gm, "").replace(/-/gm, "/"));
              filenameCategoryCache = "".concat(hasFolder).concat(filenameCategoryCache);
              fullCacheFilePath += "".concat(hasFolder);
            }
            fullCacheFilePath += "".concat(filenameCategoryCache);
            _context6.next = 11;
            return fileExist({
              fullCacheFilePath: fullCacheFilePath
            });
          case 11:
            _yield$fileExist = _context6.sent;
            fileHandle = _yield$fileExist.fileHandle;
            if (!fileHandle) {
              _context6.next = 37;
              break;
            }
            _context6.next = 16;
            return fileStats({
              fullCacheFilePath: fullCacheFilePath
            });
          case 16:
            _yield$fileStats = _context6.sent;
            stats = _yield$fileStats.stats;
            diffTime = Date.now() - stats.mtime;
            if (!(forPrismic ? diffTime > global.__appConfig__.prismicCacheStoreTimeInMilliseconds : diffTime > global.__appConfig__.invalidateCacheTime)) {
              _context6.next = 22;
              break;
            }
            _context6.next = 22;
            return _fs["default"].unlink(fullCacheFilePath, function (error) {
              if (error) {
                console.log("Cache unlink error", error);
              }
            });
          case 22:
            _context6.next = 24;
            return fileHandle.readFile({
              encoding: "utf8"
            });
          case 24:
            result = _context6.sent;
            _context6.next = 27;
            return fileHandle.close();
          case 27:
            _context6.prev = 27;
            return _context6.abrupt("return", {
              cacheFileExist: true,
              cachedRequest: JSON.parse(result),
              filenameCategoryCache: filenameCategoryCache
            });
          case 31:
            _context6.prev = 31;
            _context6.t0 = _context6["catch"](27);
            console.error("readCacheFile url: ".concat(filenameCategoryCache, ", error: ").concat(_context6.t0));
            _context6.next = 36;
            return _fs["default"].unlink(fullCacheFilePath, function (error) {
              if (error) {
                console.log("Cache unlink error after reading file", error);
              }
            });
          case 36:
            return _context6.abrupt("return", {
              cacheFileExist: false,
              cachedRequest: null,
              filenameCategoryCache: filenameCategoryCache
            });
          case 37:
            return _context6.abrupt("return", {
              cacheFileExist: false,
              cachedRequest: null,
              filenameCategoryCache: filenameCategoryCache
            });
          case 40:
            return _context6.abrupt("return", {
              cacheFileExist: null,
              cachedRequest: null,
              filenameCategoryCache: null
            });
          case 41:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[27, 31]]);
  }));
  return function readCacheFile(_x6) {
    return _ref12.apply(this, arguments);
  };
}();
exports.readCacheFile = readCacheFile;
var saveCacheFile = /*#__PURE__*/function () {
  var _ref14 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(_ref13) {
    var cacheFilePath, filenameCategoryCache, result, folders, fileName, _yield$access, isExistFile, _yield$access2, isExistFolder;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            cacheFilePath = _ref13.cacheFilePath, filenameCategoryCache = _ref13.filenameCategoryCache, result = _ref13.result;
            _context7.prev = 1;
            if (!(!process.browser && global.__appConfig__.cacheSystemEnabled && !hasSpecialCharactersInUrl(cacheFilePath) && isCharsInLimit(filenameCategoryCache))) {
              _context7.next = 26;
              break;
            }
            folders = "".concat(global.__appConfig__.cachePath).concat(cacheFilePath).concat(filenameCategoryCache.replace(/[^\/]+.json$/, ""));
            _context7.prev = 4;
            fileName = "".concat(global.__appConfig__.cachePath).concat(cacheFilePath).concat(filenameCategoryCache);
            _context7.next = 8;
            return access({
              fileOrFolder: fileName
            });
          case 8:
            _yield$access = _context7.sent;
            isExistFile = _yield$access.isExist;
            if (isExistFile) {
              _context7.next = 21;
              break;
            }
            _context7.next = 13;
            return access({
              fileOrFolder: folders
            });
          case 13:
            _yield$access2 = _context7.sent;
            isExistFolder = _yield$access2.isExist;
            if (isExistFolder) {
              _context7.next = 18;
              break;
            }
            _context7.next = 18;
            return mkdir({
              folders: folders
            });
          case 18:
            _context7.next = 20;
            return writeFile({
              fileName: fileName,
              result: result
            });
          case 20:
            return _context7.abrupt("return");
          case 21:
            _context7.next = 26;
            break;
          case 23:
            _context7.prev = 23;
            _context7.t0 = _context7["catch"](4);
            console.log("Cache write error", "".concat(global.__appConfig__.cachePath).concat(cacheFilePath).concat(filenameCategoryCache), _context7.t0);
          case 26:
            _context7.next = 31;
            break;
          case 28:
            _context7.prev = 28;
            _context7.t1 = _context7["catch"](1);
            console.log("Error on saveCacheFile", filenameCategoryCache, _context7.t1);
          case 31:
            return _context7.abrupt("return");
          case 32:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 28], [4, 23]]);
  }));
  return function saveCacheFile(_x7) {
    return _ref14.apply(this, arguments);
  };
}();
exports.saveCacheFile = saveCacheFile;
var getResultFromCache = function getResultFromCache(url, cache) {
  var _cache$data, _url$match, _cache$data2;
  var isPagination = url === null || url === void 0 ? void 0 : url.includes("p=");
  var result = (_cache$data = cache.data) === null || _cache$data === void 0 ? void 0 : _cache$data[url];
  if (result) {
    return result;
  }
  var ampersandOrQuestionMark = url.includes("?") ? "&" : "?";
  var urlWithPagination = ((_url$match = url.match(/p=[0-9]*/)) === null || _url$match === void 0 ? void 0 : _url$match[0]) === "p=1" ? url.replace(/(\?|\&)p=1/, "") : url;
  return (_cache$data2 = cache.data) === null || _cache$data2 === void 0 ? void 0 : _cache$data2[isPagination ? urlWithPagination : "".concat(url).concat(ampersandOrQuestionMark, "p=1")];
};
exports.getResultFromCache = getResultFromCache;
var setUrlInCache = function setUrlInCache(url, result, cache) {
  return cache.data[url] = result;
};
exports.setUrlInCache = setUrlInCache;